

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class AccountingJournalLineTemplate_ManagedObject

class AccountingJournalLineTemplate_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: orderRank
    set orderRank(value:string) {
        this.setValueForKey(value, 'orderRank');
    }
    get orderRank():string {
        return this.valueForKey('orderRank');
    }
    set orderRankPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'orderRank');
    }
    get orderRankPrimitiveValue():string {
        return this.primitiveValueForKey('orderRank');
    }

    // Relationship: lines
    protected _lines:MIOManagedObjectSet = null;
    get lines():MIOManagedObjectSet {
        return this.valueForKey('lines');
    }
    addLinesObject(value:AccountingJournalLineTemplate) {
        this._addObjectForKey(value, 'lines');
    }
    removeLinesObject(value:AccountingJournalLineTemplate) {
        this._removeObjectForKey(value, 'lines');
    }
    // Relationship: parent
    set parent(value:AccountingJournalLineTemplate) {
        this.setValueForKey(value, 'parent');
    }
    get parent():AccountingJournalLineTemplate {
        return this.valueForKey('parent') as AccountingJournalLineTemplate;
    }
    // Relationship: template
    set template(value:AccountingJournalTemplate) {
        this.setValueForKey(value, 'template');
    }
    get template():AccountingJournalTemplate {
        return this.valueForKey('template') as AccountingJournalTemplate;
    }
}
